<dialog id="{{ modalId }}" class="modal">
  <div class="modal-box w-full max-w-lg p-6 relative rounded-2xl">
    <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" (click)="closeModal()">✕</button>
    <div class="flex gap-2 mb-4">
      <div class="w-9 h-9 flex flex-col items-center justify-center rounded border border-base-300">
        <fa-icon [icon]="'clipboard'" class="text-primary text-xl"></fa-icon>
      </div>
      <div>
        <h2 class="text-lg font-semibold mb-1 text-primary">Request Guidelines</h2>
        <p class="text-sm text-primary-focus">{{ organization?.display_name }}</p>
      </div>
    </div>
    <form [formGroup]="guidelinesForm" (ngSubmit)="onSubmit()">
      <!-- Enabled toggle -->
      <label class="block text-base font-medium text-primary-focus pt-2">
        <span>Show request guidelines for this organization:</span>
        <div class="flex items-center gap-3 mt-1">
          <span class="text-sm text-primary">Off</span>
          <label class="relative inline-flex items-center cursor-pointer">
            <input type="checkbox" formControlName="request_guidelines_enabled" class="sr-only peer" />
            <div class="w-9 h-5 bg-base-300 rounded-full transition-colors duration-300 peer-checked:bg-info"></div>
            <span
              class="absolute left-[2px] top-[2px] bg-base-100 rounded-full h-4 w-4 shadow transition-all duration-300 peer-checked:translate-x-4"
            ></span>
          </label>
          <span class="text-sm text-primary">On</span>
        </div>
      </label>

      <!-- Data Catalog banner text -->
      <label class="block text-base font-medium text-primary-focus border-t border-base-300 pt-4 mt-4">
        <span>Data Catalog banner text:</span>
        <textarea
          formControlName="request_guidelines_catalog_text"
          rows="2"
          placeholder="Short notice shown on the Data Catalog page"
          class="textarea textarea-bordered w-full rounded mt-1 border-base-300 text-primary placeholder:text-icon-inactive focus:outline-none focus:border-base-300"
        ></textarea>
      </label>

      <!-- Request modal disclaimer text -->
      <label class="block text-base font-medium text-primary-focus mt-4">
        <span>Request modal disclaimer text:</span>
        <textarea
          formControlName="request_guidelines_modal_text"
          rows="3"
          placeholder="Longer disclaimer shown in the dataset request modal"
          class="textarea textarea-bordered w-full rounded mt-1 border-base-300 text-primary placeholder:text-icon-inactive focus:outline-none focus:border-base-300"
        ></textarea>
      </label>

      <!-- Learn more link -->
      <label class="block text-base font-medium text-primary-focus mt-4">
        <span>"Learn more" link (optional):</span>
        <input
          type="url"
          formControlName="request_guidelines_url"
          placeholder="https://..."
          class="input input-bordered w-full h-10 rounded mt-1 border-base-300 text-primary placeholder:text-icon-inactive focus:outline-none focus:border-base-300"
        />
      </label>

      <!-- Footer buttons -->
      <div class="flex justify-between gap-3 pt-4 border-t border-base-300 mt-4">
        <button
          type="button"
          class="w-[104px] h-8 rounded border border-base-300 bg-base-100 text-sm font-medium text-dark hover:bg-base-200 transition-colors"
          (click)="closeModal()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="h-8 px-6 min-w-[160px] border border-base-300 rounded text-sm text-dark font-medium hover:bg-info hover:text-white transition-colors"
        >
          Save Guidelines
        </button>
      </div>
    </form>
  </div>
  <form method="dialog" class="modal-backdrop">
    <button>close</button>
  </form>
</dialog>
